export default {
  path: '/service/detail',
  mapPath: '/service/detail',
  component: require('./index').default,
  props: true,
  parent: 'root',
  meta: {
    title: '服务商详情'
  },
  name: 'serviceDetail'
}
